/* eslint-disable no-unused-expressions */

import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import sysJwt from "../../../utils/sysJwt";
import SysForm from "../../commonComponents/sysForm";
import { post } from "../../../utils/sysAxios";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { InputTextarea } from "primereact/inputtextarea";
import { toastError } from "../../../utils/sysToast";
import { confirmAlert } from "react-confirm-alert";
import { replaceAll } from "../../../utils/stringHelper";
import SysTable from "../../commonComponents/SysTable";

class Reports extends Component {
  state = {
    data: {
      ReportName: "",
      ReportDesc: "",
      ReportCategory: "",
      ReportUsers: [],
      ReportQuery: "",
    },

    contentHeader: "Reports",

    dataUrl: "/api/data/getreports",
    singleItemUrl: "/api/data/getreport",
    addUrl: "/api/data/addreport",
    editUrl: "/api/data/editreport",
    deleteUrl: "/api/data/deletereport",

    inEditMode: false,
    inModalMode: false,

    modalHeaderAdd: "Add Report",
    modalSubmitButtonIconAdd: "fa fa-plus",
    modalHeaderEdit: "Edit Report",
    modalSubmitButtonIconEdit: "fa fa-edit",
    modalWidth: "60vw",

    editEntityId: 0,

    allCategories: [],
    allUsers: [],

    tableData: [],

    // Edit Query modal state
    inEditQueryMode: false,
    editQueryReportId: null,
    editQueryReportName: "",
    editQueryValue: "",
  };

  componentDidMount() {
    this.getData();
  }

  updateForm = (inputId, inputValue) => {
    var data = this.state.data;
    data[inputId] = inputValue;
    this.setState({ data });
  };

  showForm() {
    this.setState({ inModalMode: true });
    this.getReportCategories();
    this.getAllUsers();
  }

  closeModal() {
    var data = this.state.data;
    Object.keys(data).forEach(function (key) {
      Array.isArray(data[key]) ? (data[key] = []) : (data[key] = "");
    });
    this.setState({
      inModalMode: false,
      inEditMode: false,
      data,
      editEntityId: 0,
      allCategories: [],
      allUsers: [],
    });
    this.getData();
  }

  closeEditQueryModal() {
    this.setState({
      inEditQueryMode: false,
      editQueryReportId: null,
      editQueryReportName: "",
      editQueryValue: "",
    });
  }

  getData() {
    post(this.state.dataUrl, null, this.props.updateIsLoading).then(
      (apiResponse) => {
        this.setState({ tableData: apiResponse.data.respData.data });
      }
    );
  }

  getEditFormData(row) {
    return post(
      this.state.singleItemUrl,
      { ReportId: row.ID },
      this.props.updateIsLoading
    ).then((apiResponse) => {
      var data = this.state.data;
      const userItems = apiResponse.data.respData.user || [];

      userItems.forEach(u => {
        const val = (u !== null && typeof u === 'object' && u.value !== undefined) ? u.value : u.USER_ID;
        if (val != null) data["ReportUsers"].push(val);
      });

      data["ReportName"] = apiResponse.data.respData.data.REPORT_NAME;
      data["ReportDesc"] = apiResponse.data.respData.data.REPORT_DESC;
      data["ReportCategory"] = apiResponse.data.respData.data.REPORT_CAT;

      const seedUsers = userItems.filter(u => u !== null && typeof u === 'object' && u.label);

      this.setState({
        data,
        editEntityId: apiResponse.data.respData.data.ID,
        ...(seedUsers.length > 0 && { allUsers: seedUsers }),
      });
    });
  }

  handleOpenEditQuery(row) {
    post(
      "/api/data/GetReportQueryForEdit",
      { ReportId: row.ID },
      this.props.updateIsLoading
    ).then((apiResponse) => {
      if (apiResponse.data.respCode === 0) {
        this.setState({
          inEditQueryMode: true,
          editQueryReportId: row.ID,
          editQueryReportName: row.REPORT_NAME,
          editQueryValue: apiResponse.data.respData.query || "",
        });
      }
    });
  }

  getReportCategories() {
    post("/api/data/getreportcategoriesdropdown", null, this.props.updateIsLoading).then(
      (apiResponse) => {
        this.setState({ allCategories: apiResponse.data.respData.data });
      }
    );
  }

  getAllUsers() {
    post("/api/data/getallusersdropdown", null, this.props.updateIsLoading).then(
      (apiResponse) => {
        const fetched = apiResponse.data.respData.data || [];
        const existing = this.state.allUsers;
        const merged = [...fetched];
        existing.forEach(e => { if (!merged.find(m => m.value === e.value)) merged.push(e); });
        this.setState({ allUsers: merged });
      }
    );
  }

  handleExecute(row) {
    post(
      "/api/data/getreportquery",
      { CodeId: row.ID },
      this.props.updateIsLoading
    ).then((apiResponse) => {
      var query = apiResponse.data.respData.data;
      var queryParams = "";
      var isParameterized = false;

      if (query === null || query === undefined) {
        toastError("The report does not contain SQL to be executed");
        return;
      }

      replaceAll(
        replaceAll(
          replaceAll(
            replaceAll(
              replaceAll(
                replaceAll(
                  replaceAll(
                    query.replace(/'/g, " ").replace(/(\r\n\t|\n|\r\t)/gm, " "),
                    "%", " "
                  ),
                  "=", " "
                ),
                "(", " "
              ),
              ")", " "
            ),
            ",", " "
          ),
          ">", " "
        ),
        "<", " "
      )
        .split(" ")
        .forEach((queryWord) => {
          if (
            queryWord.includes("&") &&
            !queryParams.split("&").includes(queryWord.replace("&", ""))
          ) {
            queryParams += queryWord;
            isParameterized = true;
          }
        });

      if (isParameterized) {
        window.location.replace(
          "/dashboard/executeReport?id=" +
            row.ID +
            "&rn=" +
            encodeURIComponent(row.REPORT_NAME) +
            "&ip=" +
            isParameterized +
            "&qp=" +
            encodeURIComponent(queryParams)
        );
      } else {
        window.location.replace(
          "/dashboard/executeReport?id=" +
            row.ID +
            "&rn=" +
            encodeURIComponent(row.REPORT_NAME)
        );
      }
    });
  }

  handleDelete(row) {
    confirmAlert({
      title: this.props.t("dialog.deleteTitle"),
      message: this.props.t("dialog.deleteConfirm"),
      buttons: [
        {
          label: this.props.t("btn.yes"),
          onClick: () => {
            post(
              this.state.deleteUrl,
              { ReportId: row.ID },
              this.props.updateIsLoading
            ).then((apiResponse) => {
              apiResponse.data.respCode === 0 ? this.getData() : null;
            });
          },
        },
        { label: this.props.t("btn.cancel"), onClick: () => null },
      ],
    });
  }

  doSubmit() {
    const submitData = Object.assign({}, this.state.data);
    if (this.state.inEditMode) {
      submitData.EditEntityId = this.state.editEntityId;
    }
    post(
      this.state.inEditMode ? this.state.editUrl : this.state.addUrl,
      submitData,
      this.props.updateIsLoading
    ).then((apiResponse) => {
      if (apiResponse.data.respCode === 0) {
        this.props.updateIsLoading(false);
        this.closeModal();
      }
    });
  }

  doSaveQuery() {
    if (!this.state.editQueryValue.trim()) {
      toastError("Report query cannot be empty");
      return;
    }
    post(
      "/api/data/EditReportQuery",
      {
        ReportId: this.state.editQueryReportId,
        ReportQuery: this.state.editQueryValue,
      },
      this.props.updateIsLoading
    ).then((apiResponse) => {
      if (apiResponse.data.respCode === 0) {
        this.props.updateIsLoading(false);
        this.closeEditQueryModal();
      }
    });
  }

  getColumns() {
    const { t } = this.props;
    return [
      { id: 1, label: t("col.reportName"), field: "REPORT_NAME", width: "300px" },
      { id: 2, label: t("col.reportCategory"), field: "REPORT_CAT" },
      { id: 3, label: t("col.description"), field: "REPORT_DESC", width: "500px" },
      {
        id: 4,
        label: t("col.actions"),
        field: "SYS_ACTINOS",
        width: "130px",
        maxResizeWidth: "130px",
        resizable: false,
        pinned: true,
        cellRenderer: ({ data }) => (
          <div id="outer">
            {sysJwt.isAuthorized(["CAF0"]) && (
              <div className="inner" title="Execute">
                <button
                  className="dropdown-item btn-popup-menu"
                  disabled={this.props.isLoading}
                  onClick={() => this.handleExecute(data)}
                >
                  <i className="fa fa-bolt" />
                </button>
              </div>
            )}
            {sysJwt.isAuthorized(["CAEE"]) && (
              <div className="inner" title="Edit Report Info">
                <button
                  className="dropdown-item btn-popup-menu"
                  disabled={this.props.isLoading}
                  onClick={() => {
                    this.getEditFormData(data).then(() => {
                      this.setState({ inEditMode: true });
                      this.showForm();
                    });
                  }}
                >
                  <i className="fa fa-edit" />
                </button>
              </div>
            )}
            {sysJwt.isAuthorized(["CAEE"]) && (
              <div className="inner" title="Edit Query">
                <button
                  className="dropdown-item btn-popup-menu"
                  disabled={this.props.isLoading}
                  onClick={() => this.handleOpenEditQuery(data)}
                >
                  <i className="fa fa-code" />
                </button>
              </div>
            )}
          </div>
        ),
      },
    ];
  }

  render() {
    const { t } = this.props;
    return (
      <div className="bms-content-component fade-in">
        <div className="row align-items-center">
          <div className="col">
            <h4>{t("pages.reports")}</h4>
          </div>
          <div className="col-auto page-actions">
            {sysJwt.isAuthorized(["CAED"]) && (
              <Button
                label={t("btn.add")}
                icon="fa fa-plus"
                className="p-button-rounded p-button-secondary"
                disabled={this.props.isLoading}
                onClick={() => {
                  this.setState({ inEditMode: false });
                  this.showForm();
                }}
              />
            )}
          </div>
        </div>
        <hr />

        {/* Add / Edit Report Modal */}
        <Dialog
          visible={this.state.inModalMode}
          style={{ width: this.state.modalWidth }}
          onHide={() => this.closeModal()}
          dismissableMask={true}
          closable={false}
          header={
            <h5 className="modal-header">
              {this.state.inEditMode ? t("dialog.editTitle") : t("dialog.addTitle")}
            </h5>
          }
          footer={
            <div>
              <Button
                label={this.state.inEditMode ? t("btn.edit") : t("btn.add")}
                icon={this.state.inEditMode ? this.state.modalSubmitButtonIconEdit : this.state.modalSubmitButtonIconAdd}
                className="p-button-rounded p-button-secondary"
                disabled={this.props.isLoading}
                onClick={() => this.doSubmit()}
              />
              <Button
                label={t("btn.cancel")}
                icon="fa fa-close"
                className="p-button-rounded p-button-danger"
                onClick={() => this.closeModal()}
              />
            </div>
          }
        >
          <SysForm
            isLoading={this.props.isLoading}
            inEditMode={this.state.inEditMode}
            data={this.state.data}
            updateForm={this.updateForm}
            inputs={[
              { type: "text", id: "ReportName", label: t("col.reportName"), disabled: false },
              { type: "text", id: "ReportDesc", label: t("col.description"), disabled: false },
              { type: "dropdown", id: "ReportCategory", label: t("col.reportCategory"), options: this.state.allCategories, disabled: false },
              { type: "multiselect", id: "ReportUsers", label: t("col.users"), options: this.state.allUsers, disabled: false },
            ]}
          />
          {/* Query field — only shown when adding a new report */}
          {!this.state.inEditMode && (
            <div style={{ marginTop: "12px" }}>
              <label style={{ display: "block", marginBottom: "4px", fontWeight: "bold", color: "#555", fontSize: "13px" }}>
                {t("col.reportQuery")}
              </label>
              <InputTextarea
                value={this.state.data.ReportQuery}
                onChange={(e) => this.updateForm("ReportQuery", e.target.value)}
                rows={8}
                style={{ width: "100%", fontFamily: "monospace", fontSize: "13px" }}
                placeholder="SELECT ... FROM ... WHERE ..."
                disabled={this.props.isLoading}
              />
            </div>
          )}
        </Dialog>

        {/* Edit Query Modal */}
        <Dialog
          visible={this.state.inEditQueryMode}
          style={{ width: "70vw" }}
          onHide={() => this.closeEditQueryModal()}
          dismissableMask={true}
          closable={false}
          header={
            <h5 className="modal-header">
              {t("col.reportQuery")} — {this.state.editQueryReportName}
            </h5>
          }
          footer={
            <div>
              <Button
                label={t("btn.save")}
                icon="fa fa-check"
                className="p-button-rounded p-button-secondary"
                disabled={this.props.isLoading}
                onClick={() => this.doSaveQuery()}
              />
              <Button
                label={t("btn.cancel")}
                icon="fa fa-close"
                className="p-button-rounded p-button-danger"
                onClick={() => this.closeEditQueryModal()}
              />
            </div>
          }
        >
          <InputTextarea
            value={this.state.editQueryValue}
            onChange={(e) => this.setState({ editQueryValue: e.target.value })}
            rows={18}
            style={{ width: "100%", fontFamily: "monospace", fontSize: "13px" }}
            placeholder="SELECT ... FROM ... WHERE ..."
            disabled={this.props.isLoading}
            autoResize={false}
          />
        </Dialog>

        <SysTable
          columns={this.getColumns()}
          rows={this.state.tableData}
          pageSizes={[10, 15, 20, 25, 30]}
        />
      </div>
    );
  }
}

export default withTranslation()(Reports);
